export default __webpack_public_path__ + "static/media/goScrum.3cef8b88.png";